import DEFAULT_CANVAS_PROPERTIES from '../data/defaultCanvasProperties';

const BREAK_POINTS = {
  small: 800,
  medium: 1312,
  large: 1650,
};

const resizeCanvas = (fabricRef) => {
  if (fabricRef?.current) {
    const newCanvasWidth =
      window.innerWidth > BREAK_POINTS.large
        ? window.innerWidth * DEFAULT_CANVAS_PROPERTIES.editorExtraLargeRatio
        : window.innerWidth > BREAK_POINTS.medium
        ? window.innerWidth * DEFAULT_CANVAS_PROPERTIES.editorLargeRatio
        : window.innerWidth > BREAK_POINTS.small
        ? window.innerWidth * DEFAULT_CANVAS_PROPERTIES.editorMediumRatio
        : window.innerWidth * DEFAULT_CANVAS_PROPERTIES.editorSmallRatio;
    const scale = DEFAULT_CANVAS_PROPERTIES.width / newCanvasWidth;
    const zoom = DEFAULT_CANVAS_PROPERTIES.zoom / scale;
    fabricRef.current.setDimensions({
      width: newCanvasWidth,
      height: newCanvasWidth / DEFAULT_CANVAS_PROPERTIES.widthHeightRatio,
    });
    fabricRef.current.setZoom(zoom);
  }
};

export default resizeCanvas;
